export enum ResetFormType {
    ControlsOnly = 1,
    FormGroupsOnly,
    FormArraysOnly,
    ControlsAndFormGroupsOnly,
    DefinedPropsOnly,
    All
}
